import React, { useState, useEffect } from 'react';
import NavBar from './commonHooks/commonHooks.navBar';
import StatsService from '../controller/controller.stats';
import LogsViewer from './commonHooks/commonHooks.logViewer';

import './css/myLogs.css';

const MyLogs = () => {
    const [data, setData] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const store = await StatsService.getAll();
                setData(store.data);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, []);

    return (
        <>
            <NavBar />
            {data && <LogsViewer dat={data} />}
        </>
    );
};

export default MyLogs;
